// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"50":"enemies","180":"story","543":"equipment","652":"haven","722":"calc","803":"heroName","869":"abyss"}[chunkId] + "." + {"50":"c8dcf09c","180":"f55ff42a","543":"7badbe1b","652":"dc757955","722":"dbfe02bf","803":"b92731f1","869":"1f263610"}[chunkId] + ".js";
};